<div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <list-view [liste]="listeMotsInterdits"></list-view>
        </div>
    </div>
</div>
<floating-button [listeActions]="listeActions"></floating-button>